export default {"src":"https://static.spiritory.com/_next/static/media/auth7.9a317e97.svg","height":139,"width":138,"blurWidth":0,"blurHeight":0};